import { search } from "algolia-instant-search";

const { connectCurrentRefinements, connectClearRefinements } =
  instantsearch.connectors;

if (!customElements.get("algolia-current-refinements")) {
  class AlgoliaCurrentRefinements extends HTMLElement {
    connectedCallback() {
      this.itemTemplate = this.querySelector("template#active-item");
      this.wrapper = this.querySelector(".filters__active");
      this.list = this.querySelector(".filters__active-list");
      this.clearLink = this.querySelector(".filters__clear-all");

      this.labelMap = {};
      document
        .querySelectorAll("algolia-refinement-list[data-attribute][data-label]")
        .forEach((el) => {
          this.labelMap[el.dataset.attribute] = el.dataset.label;
        });
      document
        .querySelectorAll("algolia-price-range[data-attribute][data-heading]")
        .forEach((el) => {
          this.labelMap[el.dataset.attribute] = el.dataset.heading;
        });

      const currentRefinementsWidget = connectCurrentRefinements(
        this.renderCurrentRefinements.bind(this),
      );
      const clearRefinementsWidget = connectClearRefinements(
        this.renderClearRefinements.bind(this),
      );

      search.addWidgets([currentRefinementsWidget({}), clearRefinementsWidget({})]);
    }

    renderCurrentRefinements(renderOptions) {
      const { items, refine, createURL } = renderOptions;
      const pills = this.buildPills(items, createURL);

      this.list.innerHTML = "";

      pills.forEach((pill) => {
        const clone = this.itemTemplate.content.cloneNode(true);
        const a = clone.querySelector(".filters__active-button");
        a.href = pill.href;
        a.prepend(document.createTextNode(pill.label + " "));
        a.onclick = (e) => {
          e.preventDefault();
          pill.refinements.forEach((r) => refine(r));
        };
        this.list.appendChild(clone);
      });

      this.wrapper.style.display = pills.length ? "" : "none";
    }

    buildPills(items, createURL) {
      const pills = [];

      items.forEach((item) => {
        const attrLabel = this.labelMap[item.attribute] || item.label;

        if (item.attribute === "price") {
          const gte = item.refinements.find((r) => r.operator === ">=");
          const lte = item.refinements.find((r) => r.operator === "<=");
          const parts = [
            gte ? `From $${Number(gte.value).toFixed(2)}` : "",
            lte ? `To $${Number(lte.value).toFixed(2)}` : "",
          ].filter(Boolean);
          if (parts.length) {
            pills.push({
              label: `Price: ${parts.join(" ")}`,
              href: "#",
              refinements: item.refinements,
            });
          }
        } else {
          item.refinements.forEach((refinement) => {
            pills.push({
              label: `${attrLabel}: ${refinement.label}`,
              href: createURL(refinement),
              refinements: [refinement],
            });
          });
        }
      });

      return pills;
    }

    renderClearRefinements(renderOptions) {
      const { refine, createURL, hasRefinements } = renderOptions;
      this.clearLink.href = hasRefinements ? createURL() : "#";
      this.clearLink.onclick = (e) => {
        e.preventDefault();
        if (hasRefinements) refine();
      };
    }
  }

  customElements.define("algolia-current-refinements", AlgoliaCurrentRefinements);
}
